import React from 'react'
interface Props {
  message: React.ReactNode
  icon?: React.ReactElement
}

const EmptySection: React.FunctionComponent<Props> = ({
  message,
  icon = <i className='fal fa-search' />,
}) => {
  return (
    <div className='empty-section'>
      {icon}
      <div className='empty-section-message'>{message}</div>
    </div>
  )
}

export default EmptySection
